'use strict'

// const defaults = require('./en')

module.exports = {
  messages: {
    bank: 'Bank',
    type: 'Type',
    deposit: 'Deposit',
    withdraw: 'Withdraw'
  },
  status: {

  },
  bank: {
    bbl: 'Bangkok Bank',
    sb: 'Siam Commercial Bank',
  }
}
